import { Toaster } from "sonner";

import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

export const Route = createRootRoute({
	component: () => (
		<div className="font-inter">
			<Outlet />
			<Toaster richColors position="top-right" />
			{import.meta.env.DEV && import.meta.env.VITE_ROUTER_DEVTOOLS !== "false" && <TanStackRouterDevtools />}
		</div>
	)
});
